import { render, staticRenderFns } from "./PageRequestChanges.vue?vue&type=template&id=806117a4&"
import script from "./PageRequestChanges.vue?vue&type=script&lang=js&"
export * from "./PageRequestChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports